import { render, staticRenderFns } from "./AudienceFilterBrickSettings.vue?vue&type=template&id=bc571aaa&scoped=true&"
import script from "./AudienceFilterBrickSettings.vue?vue&type=script&lang=js&"
export * from "./AudienceFilterBrickSettings.vue?vue&type=script&lang=js&"
import style0 from "../../../../Style/audience-filter-brick.scss?vue&type=style&index=0&id=bc571aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc571aaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc571aaa')) {
      api.createRecord('bc571aaa', component.options)
    } else {
      api.reload('bc571aaa', component.options)
    }
    module.hot.accept("./AudienceFilterBrickSettings.vue?vue&type=template&id=bc571aaa&scoped=true&", function () {
      api.rerender('bc571aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/BrickSettings/AudienceFilter/AudienceFilterBrickSettings.vue"
export default component.exports